export default "__VITE_ASSET__3e6c80bc__"